/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Samples from './Samples/Samples';
import Suggestions from './Suggestions/Suggestions';
import * as sampleAction from './Samples/store/TodoList.action';
import './Todo.css';
import Costing from './CostingTsx/Costing';
import ProgressIndicator from './ProgressIndicator/Index';
import SubmitDownload from './SubmitDownloadTodo/Index';
import SupplerTodo from './SupplierTodoList/SupplierTodo';
import Testing from './Testing/Testing';
import ProductPurchaseOrderTodo from './ProductPurchaseOrderTodo/ProductPurchaseOrderTodo';
import SupportingDocument from './SupportingDocument/SupportingDocument';
import MyTodo from './MyTodo/MyTodo';

function TodoList() {
  const { childpath } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const getCount = async () => {
    await Promise.all([
      dispatch(sampleAction.getTodolistCount({ type: 'samples' })),
      dispatch(sampleAction.getTodolistCount({ type: 'suggestion' })),
      dispatch(sampleAction.getTodolistCount({ type: 'costing' })),
      dispatch(sampleAction.getTodolistCount({ type: 'progress-indicator' })),
      dispatch(sampleAction.getTodolistCount({ type: 'submit-download' })),
      dispatch(sampleAction.getTodolistCount({ type: 'testing' })),
      dispatch(sampleAction.getTodolistCount({ type: 'supplier-todo' })),
      dispatch(sampleAction.getTodolistCount({ type: 'product-purchase-order-todo' })),
      dispatch(sampleAction.getTodolistCount({ type: 'supporting-documents' })),
      dispatch(sampleAction.getTodolistCount({ type: 'my-todo' })),
    ]);
  };

  useEffect(() => {
    getCount();
  }, []);

  useEffect(() => {
    if (!childpath) {
      history.replace('/todo-list/my-todo');
    }
  }, [childpath, history]);

  return (
    <div>
      <form onSubmit={(e) => e.preventDefault()}>
        {childpath === 'sample-requests' && <Samples />}
        {childpath === 'suggestion' && <Suggestions />}
        {childpath === 'costing' && <Costing />}
        {childpath === 'progress-indicator' && <ProgressIndicator />}
        {childpath === 'submit-download' && <SubmitDownload />}
        {childpath === 'testing' && <Testing />}
        {childpath === 'supplier-todo' && <SupplerTodo />}
        {childpath === 'supporting-documents' && <SupportingDocument />}
        {childpath === 'product-purchase-order-todo' && <ProductPurchaseOrderTodo />}
        {childpath === 'my-todo' && <MyTodo />}
      </form>
    </div>
  );
}

export default TodoList;
